import React, { useEffect, useState } from "react";
import { Modal, ModalTitle, ModalBody } from "@vds/modals";
import { Select, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { chooseUserOrganization } from "../../store/actions/auth";

function OrgSelector() {
  const dispatch = useDispatch();
  const { isOpen, billingAccountIds } = useSelector((state) => ({
    isOpen: state.auth.isOrgSelectorOpen,
    billingAccountIds:
      state.auth.currentUser?.billingAccountIds ||
      state.auth.user?.billingAccountIds,
  }));

  const [organization, setOrganization] = useState({
    value:  "",
    isError: false,
  });

  useEffect(() => {
    if(isOpen){
      setOrganization((prev) => ({...prev, value: (Array.isArray(billingAccountIds) &&
                  billingAccountIds?.length > 0 &&
                  billingAccountIds[0]?.value)}))
    }
  }, [isOpen]);

  const handleChange = (val) => {
    setOrganization((prev) => ({ ...prev, value: val, isError: false }));
  };

  const handleSubmit = (e) => {
    if (!organization?.value) {
      setOrganization((prev) => ({ ...prev, isError: true }));
      return;
    }

    const activeSession = JSON.parse(sessionStorage.getItem("activeSession"));
    sessionStorage.setItem(
      "activeSession",
      JSON.stringify({
        ...activeSession,
        accountId: organization?.value || "",
      })
    );
    sessionStorage.setItem("accountId", organization?.value || "");
    sessionStorage.setItem("userRole", JSON.stringify(activeSession?.role));
    dispatch(
      chooseUserOrganization({
        ...activeSession,
        accountId: organization?.value || "",
      })
    );
  };

  const handleCloseWhenNotSelectAccount = (isOpen) => {
    if (!isOpen) {
      const accountId = sessionStorage.getItem("accountId");
      setOrganization((prev) => ({ ...prev, isError: false }));
      if (!accountId) {
        sessionStorage.removeItem("bearer_token");
        sessionStorage.removeItem("activeSession");
      }
    }
  };

  return (
    <Modal
      opened={isOpen}
      onOpenedChange={handleCloseWhenNotSelectAccount}
      surface="light"
      fullScreenDialog={false}
      disableAnimation={false}
      disableOutsideClick={false}
      ariaLabel="Org Selection Modal"
    >
      <ModalTitle>
        <div className="d-flex flex-column">
          <span
            className="font-face-vzw"
            style={{
              fontSize: "22px",
            }}
          >
            Which organization do you want to access?
          </span>
          <div
            style={{
              fontSize: "13px",
              lineHeight: "20px",
            }}
          >
            Select the organization you want to view. <br />
            You may switch organizations later by logging out and logging back
            in.
          </div>
        </div>
      </ModalTitle>
      <ModalBody>
        <div>
          <label htmlFor="organization" className="input-label-user">
            Choose Organization
          </label>
          <div className="input-container">
            <Select
              id="organization"
              className={
                organization?.isError ? "shipment-form-field-error" : ""
              }
              value={
                organization?.value
              }
              style={{ width: "100%", height: "42px" }}
              onChange={handleChange}
              options={billingAccountIds || []}
              required
            />
          </div>
          <Button
            type="primary"
            onClick={handleSubmit}
            shape="round"
            style={{
              marginTop: "15px",
              backgroundColor: "black",
              color: "white",
              fontWeight: "bold",
              width: "100%",
            }}
            size={"large"}
          >
            Submit
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default OrgSelector;
